<template>
  <div class="isis-table">
    <div v-if="!hideTableHeader" class="table-header">
      <div v-if="!hideBulkAction" :class="[bulkActionsDisplay]">
        <dropdown-button
          title="common.bulk_actions"
          class="bulk-actions"
          :actions="bulkActions"
          :btn-classes="'md-warning'"
        ></dropdown-button>
      </div>
      <selections-box
        v-if="!pagination.hidePerPageOptions"
        :title="$t('common.per_page')"
        :options="perPageOptions"
        :default="pagination.perPage"
        :style="{ marginLeft: 'auto' }"
        @input="changePerPage"
      />
    </div>
    <md-table
      class="paginated-table table-striped table-hover table-bordered"
      @md-selected="onSelect"
      :value="tableData"
      :md-sort.sync="sortData.currentSort"
      :md-sort-order.sync="sortData.currentSortOrder"
      :md-sort-fn="customSort"
    >
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        :md-selectable="selectable"
        :md-auto-select="!!selectable"
      >
        <!-- eslint-disable -->
        <md-table-cell
          class="no-number"
          :md-label="ordinalColumnTitle ? ordinalColumnTitle : $t('common.no_number')"
          v-if="!hideNoNumber"
        >
          {{ item.noNumb }}
        </md-table-cell>

        <md-table-cell
          v-for="(column_name, column) in columns"
          :md-label=$t(column_name)
          :key="column"
          :md-sort-by="canSort(column)"
          v-if="column !== 'actions'"
        >
          <span v-html="renderCell(item[column])"></span>
        </md-table-cell>
        <!-- eslint-enable -->
        <md-table-cell v-if="!hideAction" :md-label="$t('common.col_action')">
          <component
            v-if="tableActionsComponent"
            :is="tableActionsComponent"
            :item="item"
          ></component>
          <template v-else>
            <router-link
              :to="currentRoute + '/' + getEntityId(item) + '/detail'"
              v-if="canViewDetail"
            >
              <md-button class="md-just-icon md-warning md-simple table-action">
                <md-tooltip md-direction="top"
                  >{{ $t("common.view") }}
                </md-tooltip>
                <md-icon>{{
                  canAction("edit") ? "edit" : "visibility"
                }}</md-icon>
              </md-button>
            </router-link>
            <md-button
              v-if="canAction('delete')"
              class="md-just-icon md-danger md-simple table-action"
              @click.native="confirmDelete(item)"
            >
              <md-tooltip md-direction="top"
                >{{ $t("common.delete") }}
              </md-tooltip>
              <md-icon>close</md-icon>
            </md-button>

            <div class="more-actions flex" v-if="columns.actions">
              <md-button
                v-for="(actionCfg, idx) in columns.actions"
                :key="actionCfg.title + idx"
                class="md-just-icon md-simple table-action"
                :class="actionCfg.btnClass"
                @click.native="() => actionCfg.action(item)"
              >
                <md-tooltip md-direction="top"
                  >{{ actionCfg.title }}
                </md-tooltip>
                <md-icon v-if="actionCfg.icon" :class="actionCfg.iconClass">{{
                  actionCfg.icon
                }}</md-icon>
              </md-button>
            </div>
          </template>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import SelectionsBox from "./SelectionsBox";
import DropdownButton from "./DropdownButton";

export default {
  name: "YvTable",
  data() {
    return {
      perPageOptions: [5, 10, 25, 50]
      //currentSort: "id",
      //currentSortOrder: "desc"
    };
  },
  components: { SelectionsBox, DropdownButton },
  props: [
    "tableData",
    "pagination",
    "clientSort",
    "ordinalColumnTitle",
    "columns",
    "hideAction",
    "currentRoute",
    "selectable",
    "bulkActions",
    "selectedItems",
    "hideNoNumber",
    "sortData",
    "tableActionsComponent",
    "sortable",
    "hideBulkAction",
    "permissionConfig"
  ],
  computed: {
    canViewDetail() {
      if (this.permissionConfig) {
        return this.canAction("edit") || this.canAction("view");
      }
      return true;
    },
    bulkActionsDisplay() {
      return this.selectedItems.length ? "" : "hidden";
    },
    getSortable() {
      return this.sortable ? this.sortable : [];
    },
    hideTableHeader() {
      return this.hideBulkAction && this.pagination.hidePerPageOptions;
    }
  },
  methods: {
    canAction(actionName) {
      if (this.permissionConfig) {
        return this.$can(
          this.permissionConfig.actions[actionName],
          this.permissionConfig.subject
        );
      }
      return true;
    },
    customSort() {
      if (this.clientSort && !this.pagination) {
        this.clientSortFunc();
        return;
      }
      if (!this.sortData.currentSort) return;
      let orderBy = {
        order_by:
          this.sortData.currentSort + " " + this.sortData.currentSortOrder
      };
      this.$emit("sort", orderBy);
    },
    clientSortFunc() {
      if (this.sortData.currentSortOrder === "desc") {
        this.tableData.sort(
          (a, b) =>
            a[`${this.sortData.currentSort}`] -
            b[`${this.sortData.currentSort}`]
        );
      } else {
        this.tableData.sort(
          (a, b) =>
            b[`${this.sortData.currentSort}`] -
            a[`${this.sortData.currentSort}`]
        );
      }
      this.tableData.forEach((item, index) => {
        item.noNumb = index + 1;
      });
    },
    confirmDelete(item) {
      this.$emit("confirmDelete", item);
    },
    isDisplay(column) {
      if (!this.columns) return true;
      return this.columns[column];
    },
    getEntityId(item) {
      return item.id || item._id;
    },
    changePerPage(value) {
      this.$emit("change-per-page", value);
      if (+this.pagination.perPage === +value) return;

      this.pagination.perPage = value;
      this.$emit("changePage");
    },
    onSelect(items) {
      this.$emit("selectItems", items);
    },
    renderCell(cellVal) {
      if (!cellVal) return "";

      if (cellVal instanceof Array) return cellVal.join(", ");

      return cellVal.toString();
    },
    canSort(column) {
      if (this.getSortable.includes(column)) {
        return column;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.table-header {
  position: relative;
  z-index: 9;

  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.table-action {
  padding: 0 5px;
  margin: 0 2px;
}

.bulk-actions {
  margin-left: 15px;
}

.no-number {
  width: 1px;
}
</style>

<style lang="scss">
.md-table-cell.md-table-cell-selection {
  max-width: 65px !important;
}
.paginated-table table > tbody > tr > td {
  width: unset;
  max-width: unset;
}
</style>
